export default __webpack_public_path__ + "static/media/logo_other_way_around.aada4245.png";